import React from 'react'
import { Show, TextField, DateField } from '@refinedev/antd'
import { useShow, useOne } from '@refinedev/core'
import { Typography, Image } from 'antd'
import type { Tables } from '@muaa/shared'

type EventSession = Tables<'event_sessions'>
type Event = Tables<'events'>

const { Title, Text } = Typography

export function EventSessionShow() {
  const { query } = useShow<EventSession>()
  const isLoading = query.isLoading
  const record = query.data?.data

  const { query: eventQuery } = useOne<Event>({
    resource: 'events',
    id: record?.event_id ?? '',
    queryOptions: { enabled: !!record?.event_id },
  })

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Event</Title>
      <TextField value={eventQuery.data?.data?.title ?? record?.event_id ?? '—'} />

      <Title level={5}>Title</Title>
      <TextField value={record?.title} />

      <Title level={5}>Day</Title>
      <TextField value={record?.day ?? '—'} />

      <Title level={5}>Date</Title>
      {record?.date ? <DateField value={record.date} format="MMM D, YYYY" /> : <TextField value="—" />}

      <Title level={5}>Start Time</Title>
      <TextField value={record?.start_time ?? '—'} />

      <Title level={5}>End Time</Title>
      <TextField value={record?.end_time ?? '—'} />

      <Title level={5}>Location</Title>
      <TextField value={record?.location ?? '—'} />

      <Title level={5}>Address</Title>
      <TextField value={record?.address ?? '—'} />

      <Title level={5}>Attire</Title>
      <TextField value={record?.attire ?? '—'} />

      <Title level={5}>Going Count</Title>
      <TextField value={String(record?.going_count ?? 0)} />

      <Title level={5}>Description</Title>
      <TextField value={record?.description ?? '—'} />

      <Title level={5}>Hero Image</Title>
      {record?.image_url ? (
        <Image
          src={record.image_url}
          alt={record?.image_label ?? 'session hero image'}
          width={260}
          style={{ borderRadius: 8 }}
        />
      ) : (
        <Text type="secondary">No image URL — the app shows the placeholder label below.</Text>
      )}

      <Title level={5} style={{ marginTop: 12 }}>
        Image Label
      </Title>
      <TextField value={record?.image_label ?? '—'} />

      <Title level={5}>Sort Order</Title>
      <TextField value={record?.sort_order != null ? String(record.sort_order) : '—'} />
    </Show>
  )
}
